import { render, staticRenderFns } from "./GiftVouchersForBeginners.vue?vue&type=template&id=63125ff5&scoped=true&"
import script from "./GiftVouchersForBeginners.vue?vue&type=script&lang=js&"
export * from "./GiftVouchersForBeginners.vue?vue&type=script&lang=js&"
import style0 from "./GiftVouchersForBeginners.vue?vue&type=style&index=0&id=63125ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63125ff5",
  null
  
)

export default component.exports